import { useFormField as e } from "../FormField/useFormField.js";
import { FormField as t } from "../FormField/FormField.js";
import { InputBox as n } from "./InputBox.js";
import "react";
import { jsxDEV as r } from "react/jsx-dev-runtime";
//#region lib/components/Input/Input.tsx
var i = "/opt/render/project/src/shared-ui/lib/components/Input/Input.tsx";
function a({ label: a, helpText: o, errorMessage: s, prefix: c, suffix: l, id: u, containerProps: d, ...f }) {
	let { fieldId: p, hasError: m, describedBy: h } = e({
		id: u,
		helpText: o,
		errorMessage: s
	});
	return /* @__PURE__ */ r(t, {
		id: p,
		label: a,
		helpText: o,
		errorMessage: s,
		containerProps: d,
		children: /* @__PURE__ */ r(n, {
			id: p,
			hasError: m,
			prefix: c,
			suffix: l,
			"aria-invalid": m || void 0,
			"aria-describedby": h,
			...f
		}, void 0, !1, {
			fileName: i,
			lineNumber: 46,
			columnNumber: 13
		}, this)
	}, void 0, !1, {
		fileName: i,
		lineNumber: 39,
		columnNumber: 9
	}, this);
}
//#endregion
export { a as Input };
